<script setup lang="ts">
import { computed } from 'vue'
import { useMobileDialogProps } from '@/composables/useMobileDialogProps'

interface Props {
  modelValue: boolean
  title: string
  message: string
  confirmLabel: string
  confirmColor: string
  confirmTestid: string
  isLoading?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  isLoading: false
})

const emit = defineEmits<{
  'update:modelValue': [value: boolean]
  confirm: []
}>()

const dialogVisible = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value)
})

const mobileDialogProps = useMobileDialogProps(dialogVisible)

function handleConfirm() {
  emit('confirm')
}
</script>

<template>
  <v-dialog
    v-model="dialogVisible"
    max-width="400"
    v-bind="mobileDialogProps"
  >
    <v-card>
      <v-card-title>{{ title }}</v-card-title>
      <v-card-text>{{ message }}</v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn variant="text" @click="dialogVisible = false">
          Cancel
        </v-btn>
        <v-btn
          :color="confirmColor"
          variant="flat"
          :loading="isLoading"
          :data-testid="confirmTestid"
          @click="handleConfirm"
        >
          {{ confirmLabel }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
